module.exports = __webpack_public_path__ + "static/media/hall-PB.528603e9.svg";